export default Object.freeze({
    small: 'sm',
    medium: 'md',
    large: 'lg',
    fullscreen: 'fullscreen',
})
